/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigRequest } from '../../models/config-request';
import { ConfigResponse } from '../../models/config-response';
import { KeyType } from '../../models/key-type';

export interface ReplaceOrganizationConfig$Params {
  organizationKey: KeyType;
      body: ConfigRequest
}

export function replaceOrganizationConfig(http: HttpClient, rootUrl: string, params: ReplaceOrganizationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
  const rb = new RequestBuilder(rootUrl, replaceOrganizationConfig.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigResponse>;
    })
  );
}

replaceOrganizationConfig.PATH = '/administration/organizations/{organizationKey}/config';
